// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"xQ-z","carouselContainer":"yQ-z"};